import { render, staticRenderFns } from "./Forgot-Finish.vue?vue&type=template&id=0c4987d1&"
import script from "./Forgot-Finish.vue?vue&type=script&lang=js&"
export * from "./Forgot-Finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports